<template>
  <div class="price-container">
    <div class="price-content">
      <h2 class="page-text1">{{ $t("price.text1") }}</h2>
      <p class="info-text">{{ $t("price.text2") }}</p>

      <div class="price-tab">
        <div
          class="price-item"
          :class="{ active: currentPrice === item.key }"
          v-for="item in priceArr"
          :key="item.key"
          @click="currentPrice = item.key"
        >
          {{ item.text }}
        </div>
      </div>

      <div class="price-list">
        <template v-if="locale === 'zh'">
          <div class="price-item">
            <h2 class="price-title">TTS极速建联版</h2>
            <p class="price-desc">适用于轻量级TikTokShop卖家</p>

            <div class="price-info">
              <span>{{ currentPriceObj.price1 }}</span> /{{ currentPriceObj.unit }}
              <span v-if="currentPriceObj.priceRebate1" class="del">{{
                currentPriceObj.priceRebate1
              }}</span>
            </div>

            <div @click="handleContact" class="price-btn">联系购买</div>

            <dl>
              <dt>TikTokShop批量建联</dt>
              <dd>
                <el-icon><Select /></el-icon>筛选达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>发送站内信
              </dd>
              <dd>
                <el-icon><Select /></el-icon>定向邀约
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>
            </dl>
          </div>
          <div class="price-item">
            <h2 class="price-title">专业版套餐</h2>
            <p class="price-desc">适合大多数卖家,能满足1~2人共同使用</p>
            <div class="price-info">
              <span>{{ currentPriceObj.price2 }}</span> /{{ currentPriceObj.unit }}
              <span v-if="currentPriceObj.priceRebate2" class="del">{{
                currentPriceObj.priceRebate2
              }}</span>
            </div>

            <div @click="handleContact" class="price-btn">联系购买</div>

            <dl>
              <dt>子账号数量</dt>
              <dd>
                <el-icon><Select /></el-icon>赠送 <span>3</span> 个账号
              </dd>

              <dt>网页搜索达人</dt>
              <dd>
                <el-icon><Select /></el-icon>商品链接自动读取
              </dd>
              <dd>
                <el-icon><Select /></el-icon>hashtag智能生成
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>搜索次数 <span>无限次</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>搜索达人上限 <span>200达人</span>/次
              </dd>
              <dd>
                <el-icon><Select /></el-icon>导出搜索记录
                <span>5000</span>条/日<span>2000</span>条/次
              </dd>
              <dd>
                <el-icon><Select /></el-icon>查看已筛除列表
              </dd>
              <dd>
                <el-icon><Select /></el-icon>搜索/建联记录
              </dd>

              <dt>数据库搜索达人</dt>
              <dd>
                <el-icon><Select /></el-icon><span>2000w+</span> 达人资源
                <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>多维度达人数据与筛选
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>导出达人列表 <span>2000</span> 条/日，
                <span>200</span>
                条/次
              </dd>
              <dd>
                <el-icon><Select /></el-icon>建联记录
              </dd>

              <dt>批量邮件建联</dt>
              <dd>
                <el-icon><Select /></el-icon>配置自有邮件地址 <span>3</span> 个/账号
              </dd>
              <dd>
                <el-icon><Select /></el-icon>轮询发送
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI生成邮件内容<span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>赠送邮件数量 <span>20000</span> 封/月
              </dd>
              <dd>
                <el-icon><Select /></el-icon>独立批量邮件
              </dd>
              <dd>
                <el-icon><Select /></el-icon>邮件定时发送
              </dd>

              <dt>批量私信建联</dt>
              <dd>
                <el-icon><Select /></el-icon>可私信数量 <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI生成私信内容 <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>独立批量私信
              </dd>

              <dt>TikTokShop批量建联</dt>
              <dd>
                <el-icon><Select /></el-icon>筛选达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>发送站内信
              </dd>
              <dd>
                <el-icon><Select /></el-icon>定向邀约
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>

              <template v-if="currentPrice !== '月付'">
                <dt>达人智能表单 (内测礼包,赠送使用{{ currentPriceObj.useMonth1 }}月)</dt>
                <dd>
                  <el-icon><Select /></el-icon>项目创建数量 <span>无限制</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>达人数据获取Agent使用次数
                  <span>无限制</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>物流状态监控Agent使用次数
                  <span>无限制</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>TTS数据监控Agent使用次数
                  <span>无限制</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>AI脚本仿写Agent使用次数 <span>无限制</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>企业及团队成员数量 <span>无限制</span>
                </dd>
              </template>
            </dl>
          </div>
          <div class="price-item price-item-higtlight">
            <h2 class="price-title">企业版套餐</h2>
            <p class="price-desc">适合团队和公司大量使用与协作</p>

            <div class="price-info">
              <span>{{ currentPriceObj.price3 }}</span> /{{ currentPriceObj.unit }}
              <span v-if="currentPriceObj.priceRebate3" class="del">{{
                currentPriceObj.priceRebate3
              }}</span>
            </div>

            <div @click="handleContact" class="price-btn">联系购买</div>

            <dl>
              <dt>子账号数量</dt>
              <dd>
                <el-icon><Select /></el-icon>赠送 <span>10</span> 个账号
              </dd>

              <dt>网页搜索达人</dt>
              <dd>
                <el-icon><Select /></el-icon>商品链接自动读取
              </dd>
              <dd>
                <el-icon><Select /></el-icon>hashtag智能生成
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>搜索次数 <span>无限次</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>搜索达人上限 <span>1000达人</span>/次
              </dd>
              <dd>
                <el-icon><Select /></el-icon>导出搜索记录 <span>无限次</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>查看已筛除列表
              </dd>
              <dd>
                <el-icon><Select /></el-icon>搜索/建联记录
              </dd>

              <dt>数据库搜索达人</dt>
              <dd>
                <el-icon><Select /></el-icon><span>2000w+</span> 达人资源
                <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>多维度达人数据与筛选
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>导出达人列表 <span>10000</span> 条/日，
                <span>1000</span>
                条/次
              </dd>
              <dd>
                <el-icon><Select /></el-icon>建联记录
              </dd>

              <dt>批量邮件建联</dt>
              <dd>
                <el-icon><Select /></el-icon>配置自有邮件地址 <span>10</span> 个/账号
              </dd>
              <dd>
                <el-icon><Select /></el-icon>轮询发送
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI生成邮件内容<span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>赠送邮件数量 <span>100000</span> 封/月
              </dd>
              <dd>
                <el-icon><Select /></el-icon>独立批量邮件
              </dd>
              <dd>
                <el-icon><Select /></el-icon>邮件定时发送
              </dd>

              <dt>批量私信建联</dt>
              <dd>
                <el-icon><Select /></el-icon>可私信数量 <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI生成私信内容 <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>独立批量私信
              </dd>

              <dt>TikTokShop批量建联</dt>
              <dd>
                <el-icon><Select /></el-icon>筛选达人
              </dd>
              <dd>
                <el-icon><Select /></el-icon>发送站内信
              </dd>
              <dd>
                <el-icon><Select /></el-icon>定向邀约
              </dd>
              <dd>
                <el-icon><Select /></el-icon>排除重复达人
              </dd>

              <dt>达人智能表单 (内测礼包,赠送使用{{ currentPriceObj.useMonth2 }}月)</dt>
              <dd>
                <el-icon><Select /></el-icon>项目创建数量 <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>达人数据获取Agent使用次数
                <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>物流状态监控Agent使用次数
                <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>TTS数据监控Agent使用次数
                <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI脚本仿写Agent使用次数 <span>无限制</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>企业及团队成员数量 <span>无限制</span>
              </dd>
            </dl>
          </div>
        </template>
        <template v-else>
          <div class="price-item">
            <h2 class="price-title">TikTok Shop Connection</h2>
            <p class="price-desc">For lightweight TikTok Shop sellers</p>

            <div class="price-info">
              <span>{{ currentPriceObj.price1 }}</span> /{{ currentPriceObj.unit }}
              <span v-if="currentPriceObj.priceRebate1" class="del">{{
                currentPriceObj.priceRebate1
              }}</span>
            </div>

            <div @click="handleContact" class="price-btn">Subscribe</div>

            <dl>
              <dt>TikTok Shop Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>Influencer filtering
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Messaging in TikTok Shop
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Targeted Invitations
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>
            </dl>
          </div>
          <div class="price-item">
            <h2 class="price-title">Pro</h2>
            <p class="price-desc">For daily use by most of sellers, Supports 1-2 users</p>
            <div class="price-info">
              <span>{{ currentPriceObj.price2 }}</span> /{{ currentPriceObj.unit }}
              <span v-if="currentPriceObj.priceRebate2" class="del">{{
                currentPriceObj.priceRebate2
              }}</span>
            </div>

            <div @click="handleContact" class="price-btn">Subscribe</div>

            <dl>
              <dt>Sub-accounts</dt>
              <dd>
                <el-icon><Select /></el-icon>Includes <span>3</span> sub-accounts
              </dd>

              <dt>TikTok Search</dt>
              <dd>
                <el-icon><Select /></el-icon>Auto product link parsing
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI generates precise hashtags
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Search attempts: <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Search limit:
                <span>200 influencers/search</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Export search records:
                <span>5,000/day, 2,000/batch</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>View the filtered influencers list
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Search/Outreach History
              </dd>

              <dt>Database Search</dt>
              <dd>
                <el-icon><Select /></el-icon><span>20M+</span> Influencer database:
                <span>Unlimited access</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Multi-dimensional filtering
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>
              <dd>
                <el-icon><Select /></el-icon> Export influecers:
                <span>2,000/day, 200/batch </span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Outreach Records
              </dd>

              <dt>Bulk Email Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>
                <p>The limit number of sender addresses: <span>3/account</span></p>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Rotational sending
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI-generated content <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Complimentary emails:
                <span>20,000/month</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Bulk Email
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Scheduled Email
              </dd>

              <dt>Bulk DM Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>Direct messages: <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI-generated DMs: <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Bulk Direct Messages
              </dd>

              <dt>TikTok Shop Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>Influencer filtering
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Messaging in TikTok Shop
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Targeted Invitations
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>

              <template v-if="currentPrice !== '月付'">
                <dt>
                  Creator Management Agent (Beta Gift –
                  {{ currentPriceObj.useMonth1 }} month free)
                </dt>
                <dd>
                  <el-icon><Select /></el-icon>Project creation <span>Unlimited</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>Creator Data Agent usage
                  <span>Unlimited</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>Logistics Tracking Agent usage
                  <span>Unlimited</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>TTS Data Agent usage <span>Unlimited</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>AI Script Rewrite Agent usage
                  <span>Unlimited</span>
                </dd>
                <dd>
                  <el-icon><Select /></el-icon>Company & team members
                  <span>Unlimited</span>
                </dd>
              </template>
            </dl>
          </div>
          <div class="price-item price-item-higtlight">
            <h2 class="price-title">Enterprise</h2>
            <p class="price-desc">
              For heavy use and collaborative by all kinds of teams.
            </p>

            <div class="price-info">
              <span>{{ currentPriceObj.price3 }}</span> /{{ currentPriceObj.unit }}
              <span v-if="currentPriceObj.priceRebate3" class="del">{{
                currentPriceObj.priceRebate3
              }}</span>
            </div>

            <div @click="handleContact" class="price-btn">Subscribe</div>

            <dl>
              <dt>Sub-accounts</dt>
              <dd>
                <el-icon><Select /></el-icon>Includes <span>10</span> sub-accounts
              </dd>

              <dt>TikTok Search</dt>
              <dd>
                <el-icon><Select /></el-icon>Auto product link parsing
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI generates precise hashtags
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Search attempts: <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Search limit:
                <span>1000 influencers/search</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Export search records:
                <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>View the filtered influencers list
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Search/Outreach History
              </dd>

              <dt>Database Search</dt>
              <dd>
                <el-icon><Select /></el-icon><span>20M+</span> Influencer database:
                <span>Unlimited access</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Multi-dimensional filtering
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>
              <dd>
                <el-icon><Select /></el-icon> Export influecers:
                <span>10,000/day, 1,000/batch</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Outreach Records
              </dd>

              <dt>Bulk Email Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>
                <p>The limit number of sender addresses: <span>10/account</span></p>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Rotational sending
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI-generated content <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Complimentary emails:
                <span>100,000/month</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Bulk Email
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Scheduled Email
              </dd>

              <dt>Bulk DM Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>Direct messages: <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI-generated DMs: <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Bulk Direct Messages
              </dd>

              <dt>TikTok Shop Outreach</dt>
              <dd>
                <el-icon><Select /></el-icon>Influencer filtering
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Messaging in TikTok Shop
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Targeted Invitations
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Duplicate influencers exclusion
              </dd>

              <dt>
                Creator Management Agent (Beta Gift –
                {{ currentPriceObj.useMonth2 }} month free)
              </dt>
              <dd>
                <el-icon><Select /></el-icon>Project creation <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Creator Data Agent usage
                <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Logistics Tracking Agent usage
                <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>TTS Data Agent usage <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>AI Script Rewrite Agent usage
                <span>Unlimited</span>
              </dd>
              <dd>
                <el-icon><Select /></el-icon>Company & team members <span>Unlimited</span>
              </dd>
            </dl>
          </div>
        </template>
      </div>

      <div class="price-footer">
        {{ $t("price.text6") }}
        <span @click="handleContact"> {{ $t("price.text7") }}</span>
      </div>
    </div>
  </div>

  <linkUsDialog v-model="showDialog"></linkUsDialog>

  <img
    class="w-[100px] h-[131px] fixed right-[40px] top-[48vh] cursor-pointer"
    :src="toolImg"
    alt=""
    @click="handleOpenDialog"
  />

  <contactDialog v-model="showDialog1"></contactDialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { Select } from "@element-plus/icons-vue";
import linkUsDialog from "@/components/Dialog/linkUsDialog.vue";
import { usePagePrice } from "@/hooks/usePagePrice.ts";
import contactDialog from "@/components/Dialog/contactDialog.vue";

const showDialog1 = ref(false);
function handleOpenDialog() {
  showDialog1.value = true;
}

const { priceArr, currentPrice, currentPriceObj, toolImg, locale } = usePagePrice();

const showDialog = ref(false);
function handleContact() {
  showDialog.value = true;
}
</script>

<style scoped lang="scss">
.price-container {
  background-color: #fefcff;
  padding-top: 190px;
  width: 100vw;
  overflow: hidden;

  .page-text1 {
    font-family: Libre Baskerville, Libre Baskerville;
    font-weight: 400;
    font-size: 64px;
    color: #000000;
    text-align: center;
  }
  .info-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 20px;
    color: #858481;
    text-align: center;
  }

  .price-content {
    margin: auto;
    .price-tab {
      margin: auto;
      margin-top: 66px;
      display: flex;
      justify-content: center;
      background-color: #9038ff;
      width: max-content;
      border-radius: 8px;

      > div {
        margin: 4px;
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        color: #fff;
        transition: all 0.3s;
        cursor: pointer;
        border-radius: 8px;
      }
      .active {
        color: #9038ff;
        background-color: #fff;
      }
    }

    .price-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 32px;
      margin: auto;
      margin-top: 32px;
      transform: scale(0.75);
      margin-top: -200px;
      margin-bottom: -200px;
      width: 1500px;

      .price-item {
        background: #ffffff;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #e1e1e1;
        padding: 40px 24px;
        color: #000000;

        .price-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          margin-bottom: 8px;
        }

        .price-desc {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #858481;
          height: 40px;
          margin-bottom: 40px;
        }

        .price-info {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 24px;

          span {
            font-size: 52px;
          }

          .del {
            color: #858481;
            margin-left: 12px;
            font-size: 24px;
          }
        }

        .price-btn {
          border-radius: 100px 100px 100px 100px;
          border: 1px solid #000000;
          height: 56px;
          line-height: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 60px;
          cursor: pointer;
          font-family: PingFang HK, PingFang HK;
          font-weight: 600;
          font-size: 20px;
        }

        dl {
          padding-left: 20px;
          dt {
            margin-top: 32px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            position: relative;
            padding-left: 7px;
            margin-bottom: 4px;

            &::before {
              content: "";
              position: absolute;
              width: 6px;
              height: 6px;
              background-color: #000;
              border-radius: 50%;
              left: -7px;
              top: 50%;
              transform: translateX(-50%);
            }
          }

          dd {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #535350;
            margin-left: -18px;
            margin-top: 8px;
            display: flex;
            align-items: center;

            .el-icon {
              margin-right: 8px;
            }

            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #000000;
              padding: 0 4px;
            }
          }
        }
      }

      .price-item-higtlight {
        background-color: #9038ff;
        border: solid 1px #9038ff;
        color: #fff;
        .price-desc {
          color: #fff;
        }
        .price-btn {
          color: #9038ff;
          background-color: #fff;
          border: solid 0px #fff;
        }
        .price-info {
          .del {
            color: #fff;
          }
        }
        dt::before {
          background-color: #fff !important;
        }
        dd {
          color: #fff !important;
          .el-icon {
            color: #fff !important;
          }
          span {
            color: #ffd102 !important;
          }
        }
      }
    }

    .price-footer {
      margin-top: 32px;
      padding-bottom: 98px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 300;
      font-size: 20px;
      color: #000000;

      span {
        text-decoration: underline;
        color: #9038ff;
        cursor: pointer;
      }
    }
  }
}
</style>
